module.exports = __webpack_public_path__ + "img/livestation.87bd7d27.png";